import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import ic_upload from "../../../assets/images/ic_upload.svg";
import ic_upload_dark from "../../../assets/images/ic_upload_dark.svg";

import Logo from '../../../assets/images/wifi-attendance.svg'
import ic_green_pen from "../../../assets/images/ic_green_pen.svg";
import { Modal } from "react-bootstrap";
import { AppContext } from "../../../context/AppContext";
import dummyLogo from "../../../assets/images/add.svg";
import DatePicker from "react-datepicker";
import calendersvg from "../../../assets/images/calender_19.svg";
import calendersvg_dark from "../../../assets/images/calender_19_dark.svg";

import "react-datepicker/dist/react-datepicker.css";
import ApiConfig from "../../../api/ApiConfig";
import rb_logo from "../../../assets/images/custom-rb-logo.png";
import Form from "react-bootstrap/Form";
import ProductTable from "./ProductTable";
import {
  PostCallWithAuthToken,
  putWithAuthCall,
  simpleGetCall,
  simpleGetCallWithToken,
} from "../../../api/ApiServices";
import { ToWords } from "to-words";
// import { notify, notifyError } from "../../sharedComponent/toaster/notify";
import {
  displayDateFormat,
  getDateddmmyyyy,
  roundedOff,
  ssingleProductHandler,
  toFixedValue,
} from "../../../common";
import BackDropLoader from "../../../sharedComponent/BackDropLoader";
import Swal from "sweetalert2";
import { ToastMsg } from "../../TostMsg";

const SalesServiceForm = ({
  CopiedData,
  newInvoice,
  handleInvoiceSearch,
  invoiceNo,
  setInvoiceNo,
  reciveInvoiceId,
  getInvoiceData,
  setIsView,
  setPrintButton,
  setpdfCheck,
  getCustomerInvoices,
  invoiceEditData,
  invoiceAction,
  setInvoiceAction,
  appSettings,
  exportPDFWithComponent,
  setHideBothSide,
}) => {
  const {
    formFormat,
    Dark,
    setHideCopy,
    currentRoute,
    logo,
    setLogo,
    setSidebar,
    financialYearId,
    userData
  } = useContext(AppContext);
  // Get Permissions from localStroge
  const userPermissions = JSON.parse(localStorage.getItem("user"));
  const permissions = userPermissions?.permissions;

  const toWords = new ToWords();
  var commaNumber = require("comma-number");

  // States
  const [backDropOpen, setBackDropOpen] = useState(false);
  const [invGenerateState, setInvGenerateState] = useState(0);
  const [validated, setValidated] = useState(false);
  const [products, setProducts] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState(new Date());
  const [selectedDueDate, setSelectedDueDate] = useState(new Date());
  const [poDate, setPodate] = useState(new Date());
  const [hsnCodes, setHsnCodes] = useState([]);
  const [account, setAccount] = useState([]);
  const [addedNew, setAddedNew] = useState(false);
  const [nameList, setNameList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState([]);

  const [invoiceFormDetails, setInvoiceFormDetails] = useState({
    financialYearId: financialYearId,
    invoiceDate: new Date().toISOString().toString(),
    dueDate: new Date().toISOString().toString(),
    paymentTermId: "",
    paymentTerms: "",
    subTotal: 0,
    cgst: 0,
    cgstAmount: 0,
    sgst: 0,
    sgstAmount: 0,
    igst: 0,
    igstAmount: 0,
    suppName: "",
    suppAddr: "",
    suppState: "",
    suppCountry: "",
    suppEmail: "",
    suppContactNo: "",
    suppGSTNo: "",
    suppPANNo: "",
    placeOfSupply: "",
    modeOfPay: "",
    chequeNo: "",
    bankName: "",
    custName: "",
    billAddr: "",
    billState: "",
    billCountry: "",
    billEmail: "",
    billContactNo: "",
    billGSTNo: "",
    billPANNo: "",
    billCity: "",
    billPincode: "",
    shipCustName: "",
    shipAddr: "",
    shipState: "",
    shipCountry: "",
    shipEmail: "",
    shipContactNo: "",
    shipGSTNo: "",
    shipPANNo: "",
    grossAmount: 0,
    gstAmount: 0,
    totalAmount: 0,
    PONo: "",
    podate: null,
    Ewaybill: "",
    modeofTransport: "",
    vehicleNumber: "",
    isSEZEnabled: false,
    lutBondNo: "",
  });
  console.log("invoiceFormDetails,", invoiceFormDetails);
  const [productDetails, setProductDetails] = useState([
    {
      gst: 0,
      hsnId: 0,
      productId: 0,
      gstAmount: 0,
      igst: 0,
      igstAmount: 0,
      sgst: 0,
      sgstAmount: 0,
      cgst: 0,
      cgstAmount: 0,
      discPer: 0,
      discAmount: 0,
      unitId: 15,
      productName: "",
      hsnCode: "",
      qty: 0,
      rate: 0,
    },
  ]);
  console.log("productDetails,", productDetails);
  let lengthOfPlaceOfSupply = invoiceFormDetails?.placeOfSupply.length;
  const isStateSame =
    invoiceFormDetails.suppGSTNo?.substring(0, 2) ===
    invoiceFormDetails.placeOfSupply.substring(
      lengthOfPlaceOfSupply - 2,
      lengthOfPlaceOfSupply
    );

  const amountInWords = toWords.convert(
    invoiceFormDetails.totalAmount ? invoiceFormDetails.totalAmount : 0,
    {
      currency: true,
    }
  );

  const [newProduct, setNewProduct] = useState({
    productCode: "",
    productName: "",
    rate: 0,
    ledgerAccId: 0,
    taxRate: "",
    hsnCode: "",
    hsnId: 0,
    unit: "",
    unitId: 0,
  });

  useEffect(() => {
    getStates();
    getHsnCodes();
    getAccounts();
    getProducts();
    // getCustomerNames();
    getUnits();
    fetchPaymentTerms();
    getInvoiceNo();
    getClientsNames();

  }, []);
  const [paymentTerms, setPaymentTerms] = useState([]);
  console.log("paymentTerms,", paymentTerms);
  const fetchPaymentTerms = async () => {
    try {
      const res = await simpleGetCallWithToken(ApiConfig.FETCH_PAYMENT_TERMS);
      console.log("res,", res);
      if (res.success) {
        setPaymentTerms(res.data);
      }
    } catch (error) {
      console.log("Catch error from payment terms API response,", error);
    }
  };

  const getStates = async () => {
    setBackDropOpen(false)
    simpleGetCall(ApiConfig.GET_STATES)
      .then((res) => {
        if (res.success) {
          if (res.data !== null) setStates(res.data);
          setBackDropOpen(false);
          simpleGetCall(ApiConfig.GET_PROFILE_DATA).then(
            (profileData) => {
              setBackDropOpen(false);
              if (profileData.success === true) {
                let supplierGstNumber = profileData.data.gstNo.substring(0, 2);
                let state =
                  res.data &&
                  res.data.filter(
                    (state, i) => state.code == supplierGstNumber
                  )[0];
                setLogo({
                  companyLogo: profileData.data.companyLogo,
                  signtureLogo: profileData.data.signature,
                  terms: profileData.data.terms,
                });

                if (invoiceAction === "edit") {
                  setIsSezDeveloper(
                    invoiceEditData?.isSEZEnabled ? true : false
                  );
                  setInvoiceNo(invoiceEditData?.invoiceNo);
                  setInvoiceFormDetails({
                    ...invoiceFormDetails,
                    id: invoiceEditData?.id ? invoiceEditData?.id : "",
                    invoiceNo: invoiceEditData?.invoiceNo
                      ? invoiceEditData?.invoiceNo
                      : "",
                    invoiceDate: invoiceEditData?.invoiceDate
                      ? invoiceEditData?.invoiceDate
                      : "",
                    dueDate: invoiceEditData?.dueDate
                      ? invoiceEditData?.dueDate
                      : "",
                    paymentTermId: invoiceEditData?.paymentTermId
                      ? invoiceEditData?.paymentTermId
                      : "",
                    paymentTerms: invoiceEditData?.paymentTerms
                      ? invoiceEditData?.paymentTerms
                      : "",
                    placeOfSupply: invoiceEditData?.placeOfSupply
                      ? invoiceEditData?.placeOfSupply
                      : "",
                    PONo: invoiceEditData?.poNo ? invoiceEditData?.poNo : "",
                    podate: invoiceEditData?.poDate
                      ? invoiceEditData?.poDate
                      : null,
                    modeOfPay: invoiceEditData?.modeOfPay
                      ? invoiceEditData?.modeOfPay
                      : "",
                    chequeNo: invoiceEditData?.chequeNo
                      ? invoiceEditData?.chequeNo
                      : "",
                    bankName: invoiceEditData?.bankName
                      ? invoiceEditData?.bankName
                      : "",
                    custName: invoiceEditData?.custName
                      ? invoiceEditData?.custName
                      : "",
                    billAddr: invoiceEditData?.billAddr
                      ? invoiceEditData?.billAddr
                      : "",
                    billCity: invoiceEditData?.billCity
                      ? invoiceEditData?.billCity
                      : "",
                    billPincode: invoiceEditData?.billPincode
                      ? invoiceEditData?.billPincode
                      : "",
                    billEmail: invoiceEditData?.billEmail
                      ? invoiceEditData?.billEmail
                      : "",
                    billContactNo: invoiceEditData?.billContactNo
                      ? invoiceEditData?.billContactNo
                      : "",
                    billGSTNo: invoiceEditData?.billGSTNo
                      ? invoiceEditData?.billGSTNo
                      : "",
                    billState: invoiceEditData?.billState
                      ? invoiceEditData?.billState
                      : "",
                    billPANNo: invoiceEditData?.billPANNo
                      ? invoiceEditData?.billPANNo
                      : "",
                    billCity: invoiceEditData?.billCity
                      ? invoiceEditData?.billCity
                      : "",
                    billPincode: invoiceEditData?.billPincode
                      ? invoiceEditData?.billPincode
                      : "",
                    shipCustName: invoiceEditData?.shipCustName
                      ? invoiceEditData?.shipCustName
                      : "",
                    shipAddr: invoiceEditData?.shipAddr
                      ? invoiceEditData?.shipAddr
                      : "",
                    shipEmail: invoiceEditData?.shipEmail
                      ? invoiceEditData?.shipEmail
                      : "",
                    shipContactNo: invoiceEditData?.shipContactNo
                      ? invoiceEditData?.shipContactNo
                      : "",
                    shipGSTNo: invoiceEditData?.shipGSTNo
                      ? invoiceEditData?.shipGSTNo
                      : "",
                    shipPANNo: invoiceEditData?.shipPANNo
                      ? invoiceEditData?.shipPANNo
                      : "",
                    igst: invoiceEditData?.igst ? invoiceEditData?.igst : 0,
                    igstAmount: invoiceEditData?.igstAmount
                      ? invoiceEditData?.igstAmount
                      : 0,
                    isSEZEnabled: invoiceEditData?.isSEZEnabled ? true : false,
                    lutBondNo: invoiceEditData?.lutBondNo
                      ? invoiceEditData?.lutBondNo
                      : "",

                    suppName: invoiceEditData?.suppName
                      ? invoiceEditData?.suppName
                      : "",
                    suppAddr: invoiceEditData?.suppAddr
                      ? invoiceEditData?.suppAddr
                      : "",
                    suppEmail: invoiceEditData?.suppEmail
                      ? invoiceEditData?.suppEmail
                      : "",
                    suppContactNo: invoiceEditData?.suppContactNo
                      ? invoiceEditData?.suppContactNo
                      : "",
                    suppGSTNo: invoiceEditData?.suppGSTNo
                      ? invoiceEditData?.suppGSTNo
                      : "",
                    suppPANNo: invoiceEditData?.suppPANNo
                      ? invoiceEditData?.suppPANNo
                      : "",
                    suppPincode: invoiceEditData?.suppPincode
                      ? invoiceEditData?.suppPincode
                      : "",
                  });

                  let newArr = invoiceEditData?.invoiceDetails.map((item) => {
                    return {
                      ...item,
                      unitId: item?.unitId ? item?.unitId : 15,
                    };
                  });
                  setProductDetails([
                    ...newArr,
                    {
                      id: 0,
                      hsnId: 0,
                      productId: 0,
                      gst: 0,
                      gstAmount: 0,
                      igst: 0,
                      igstAmount: 0,
                      sgst: 0,
                      sgstAmount: 0,
                      cgst: 0,
                      cgstAmount: 0,
                      discPer: 0,
                      discAmount: 0,
                      unitId: 15,
                      productName: "",
                      hsnCode: "",
                      qty: 0,
                      rate: 0,
                    },
                  ]);
                } else {
                  setInvoiceFormDetails({
                    ...invoiceFormDetails,
                    suppName: profileData.data.companyName,
                    suppAddr: profileData.data.address,
                    suppEmail: profileData.data.email,
                    suppContactNo: profileData.data.contactNo,
                
                    suppGSTNo: profileData.data.gstNo,
                    suppPANNo: profileData.data.panNo,
                    placeOfSupply: state ? `${state.name}-${state.code}` : "",
                    suppPincode: profileData.data.pincode,
                  });
                }
              }
            }
          );
        } else {
          console.log(res);
          return;
        }
      })
      .catch((err) => console.log(err));
  };

  const getCustomerNames = async () => {
    try {
      const response = await simpleGetCallWithToken(
        ApiConfig.GET_CUSTOMER_NAMES  

      
      );
      if (response.success === true) {
        setNameList(response.data);
      }
    } catch (error) {
      console.log("Error response,", error);
    }
  };

  const [clientList, setClientList] = useState([]);
 
    const getClientsNames = async () => {
    try {
      const response = await simpleGetCallWithToken(
      
        ApiConfig.GET_CLIENTS + `currentPage=1&pageSize=9999`
      );
      if (response.success === true) {
        setClientList(response.data);
      }
    } catch (error) {
      console.log("Error response,", error);
    }
  };

 

  const getCustomerBillingData = async (billName) => {
    setBackDropOpen(false);
    let dataObj = {
      id: billName.id,
    };

/* new code i added here just to save what is comming from api directly */

       setInvoiceFormDetails({
            ...invoiceFormDetails,
            custName: billName.firstName,
            billAddr: billName.address,
            billEmail: billName.email,
            billContactNo: billName.phone,
            billGSTNo: billName.gstNo,
            billPANNo: billName.panNo,
            // placeOfSupply: state ? `${state.name}-${state.code}` : "",
            billPincode: billName.pincode,
          });



    /* below commented old api */
    // try {
    //   const res = await PostCallWithAuthToken(
    //     ApiConfig.GET_CUSTOMER_BILLING_DATA,
    //     JSON.stringify(dataObj)
    //   );
    //   if (!res.error) {
    //     setBackDropOpen(false);
    //     if (res.json.success === true) {
    //       let state =
    //         states &&
    //         states.filter(
    //           (state, i) => state.code == res.json.data.gstNo.substring(0, 2)
    //         )[0];

    //       setInvoiceFormDetails({
    //         ...invoiceFormDetails,
    //         custName: res.json.data.customerName,
    //         billAddr: res.json.data.billAddr,
    //         billEmail: res.json.data.email,
    //         billContactNo: res.json.data.contactNo,
    //         billGSTNo: res.json.data.gstNo,
    //         billPANNo: res.json.data.panNo,
    //         placeOfSupply: state ? `${state.name}-${state.code}` : "",
    //         billPincode: res.json.data.pincode,
    //       });
    //     }
    //   } else {
    //     console.log("error res,", res);
    //   }

     
    // } catch (error) {
    //   console.log("error res,", error);
    // } finally {
    //   setBackDropOpen(false);
    // }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      addNewProductApiCall();
    }
    setValidated(true);
  };

  const getFocus = () => {
    if (invoiceFormDetails.placeOfSupply.trim() === "") {
      document.getElementById("placeOfSupply").focus();
      return;
    }
    if (invoiceFormDetails.modeOfPay.trim() === "") {
      document.getElementById("modeOfPay").focus();
      return;
    }
    if (
      invoiceFormDetails.chequeNo.trim() === "" &&
      invoiceFormDetails.modeOfPay === "Cheque"
    ) {
      document.getElementById("chequeNo").focus();
      return;
    }
    if (
      invoiceFormDetails.bankName.trim() === "" &&
      invoiceFormDetails.modeOfPay === "Cheque"
    ) {
      document.getElementById("bankName").focus();
      return;
    }
    // if (invoiceFormDetails.modeofTransport.trim() === "") {
    //   document.getElementById("modeofTransport").focus();
    //   return;
    // }
    // if (
    //   invoiceFormDetails.vehicleNumber.trim() === "" &&
    //   invoiceFormDetails.modeofTransport === "By Road"
    // ) {
    //   document.getElementById("vehicleNumber").focus();
    //   return;
    // }
    if (invoiceFormDetails.custName.trim() === "") {
      document.getElementById("custName").focus();
      return;
    }
    if (invoiceFormDetails.billAddr.trim() === "") {
      document.getElementById("billAddr").focus();
      return;
    }
  };

  const saveInvoiceForm = (event) => {
    event.preventDefault();

    const form = event.currentTarget;
    if (form?.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      // notifyError("Please fill all required fields");
    } else if (
      productDetails[0].productName === "" &&
      productDetails[0].discAmount == 0
    ) {
      setErrMsg({ ...errMsg, products: "Please enter product details" });
      // notifyError("Please Fill Product Details");
    } else {
      Swal.fire({
        title: "Do you want to submit the invoice?",
        showDenyButton: true,
        // showCancelButton: true,
        confirmButtonText: "Yes",
        denyButtonText: `Cancel`,
      }).then((result) => {
        if (result.isConfirmed) {
          setLoading(true);
          let filteredProductList = productDetails.filter((item, index) => {
            if (item.productName || item.hsnCode || item.cgst || item.sgst) {
              return item;
            }
          });

      
          const updatedProductList = filteredProductList.map(item => ({
  ...item,
  gst: Number(item.gst) > 0 ? item.gst : 0
}));
          var data = {
            ...invoiceFormDetails,
            // invoiceDetails: filteredProductList,
              invoiceDetails: updatedProductList,
            invoiceNo: invoiceNo,
          };
          PostCallWithAuthToken(ApiConfig.SALESSERVICE, JSON.stringify(data))
            .then((res) => {
              if (res.json && res.json?.success === true) {
                setLoading(false);
                getInvoiceNo();
                getSelectedInvoiceId(res.json.data.id);
                setInvGenerateState(invGenerateState + 1);
                // notify(res.json.message);
                // getCustomerNames();
                getCustomerInvoices("");
                getInvoiceData(res.json.data.id);
                // setpdfCheck(true)
                setIsView(true);
                setPrintButton(true);
                setHideCopy(true);

                setHideBothSide({
                  lg: "8",
                  displayBlock: "",
                });
                setSidebar(true);
              } else {
                // notifyError(res.json.message);
                ToastMsg('error', res?.json?.message)
                setLoading(false);
                return;
              }
            })
            .catch((err) => {

              console.log(err);
              setLoading(false);
            });
        }
      });
    }
  };

  // UPDATE_SALES_GOODS_INVOICE
  const updateInvoice = (event) => {
    event.preventDefault();

    const form = event.currentTarget;
    if (form?.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      // notifyError("Please fill all required fields");
    } else if (
      productDetails[0].productName === "" &&
      productDetails[0].discAmount !== 0
    ) {
      setErrMsg({ ...errMsg, products: "Please enter product" });
      // notifyError("Please fill all required fields");
    } else {
      Swal.fire({
        title: "Do you want to update the invoice?",
        showDenyButton: true,
        // showCancelButton: true,
        confirmButtonText: "Yes",
        denyButtonText: `Cancel`,
      }).then((result) => {
        if (result.isConfirmed) {
          setLoading(true);
          let filteredProductList = productDetails.filter((item, index) => {
            if (item.productName || item.hsnCode || item.cgst || item.sgst) {
              return item;
            }
          });
          var data = {
            ...invoiceFormDetails,
            invoiceDetails: filteredProductList,
          };
          putWithAuthCall(
            ApiConfig.UPDATE_SALES_GOODS_INVOICE,
            JSON.stringify(data)
          )
            .then((res) => {
              if (res.success === true) {
                setInvoiceAction("submitInvoice");
                setInvGenerateState(invGenerateState + 1);
                setLoading(false);
                ToastMsg('success', res?.message)
                // notify(res.json.message);
                setHideCopy(true);
                // getCustomerNames();
                getCustomerInvoices("");
                getInvoiceData(res.data.id);
                getSelectedInvoiceId(res.data.id);

                setHideBothSide({
                  lg: "8",
                  displayBlock: "",
                });
                setSidebar(true);
              } else {
                setLoading(false);
                ToastMsg('error', 'Something Went Wrong')
                // notifyError(res.json.message);
              }
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
            });
        }
      });
    }
  };

  const addNewProductApiCall = () => {
    PostCallWithAuthToken(ApiConfig.ADD_NEW_PRODUCT, JSON.stringify(newProduct))
      .then((res) => {
        if (res.json.success) {
          setAddedNew(false);
          // getProducts();
          // notify("Product added successfully");
        }
      })
      .catch((err) => console.log(err));
  };

  const getHsnCodes = () => {
    simpleGetCallWithToken(ApiConfig.GET_HSNCODE)
      .then((res) => {
        setHsnCodes(res.data);
      })
      .catch((err) => console.log(err));
  };

  const getAccounts = () => {
    simpleGetCallWithToken(ApiConfig.GET_ACCOUNT)
      .then((res) => {
        setAccount(res.data);
      })
      .catch((err) => console.log(err));
  };

  // API CALL FUNCTION FOR INVIOCE NUMBER
  const getInvoiceNo = () => {
    const body = {
      type: "SalesService",
    };

    PostCallWithAuthToken(ApiConfig.GET_INVOICENO, JSON.stringify(body))
      .then((res) => {
        if (res.json && res.json?.success === true) {
          setInvoiceNo(res.json.data);
        }
      })
      .catch((err) => console.log(err));
  };

  const getProfileData = () => {
    setBackDropOpen(true);
    simpleGetCallWithToken(ApiConfig.GET_PROFILE_DATA)
      .then((res) => {
        setBackDropOpen(false);
        setInvoiceFormDetails({
          ...invoiceFormDetails,
          suppName: res.data.companyName,
          suppAddr: res.data.address,
          // suppContactNo: "7745745522",
          suppContactNo: res.data.contactNo,
          suppGSTNo: res.data.gstNo,
          suppPANNo: res.data.panNo,
        });
      })
      .catch((err) => console.log(err));
  };

  // API CALL FUNCTION FOR PRODUCTS
  const getProducts = () => {
    simpleGetCallWithToken(ApiConfig.GET_PRODUCTS)
      .then((res) => {
        if (res.success && res.success === true) {
          setProducts(res.data);
        }
      })
      .catch((err) => console.log(err));
  };

  const [units, setUnits] = useState([]);

  const getUnits = () => {
    simpleGetCallWithToken(ApiConfig.GET_UNITS)
      .then((res) => {
        if (res.success === true) {
          setUnits(res.data);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    setInvoiceFormDetails({
      ...invoiceFormDetails,
      placeOfSupply: CopiedData ? CopiedData.placeOfSupply : "Maharashtra-27",
      PONo: CopiedData.poNo ? CopiedData.poNo : "",
      Ewaybill: CopiedData.ewayBillNo ? CopiedData.ewayBill : "",
      modeOfPay: CopiedData.modeOfPay ? CopiedData.modeOfPay : "",
      modeofTransport: CopiedData.modeOfTransport
        ? CopiedData.modeOfTransport
        : "",
      chequeNo: CopiedData.chequeNo ? CopiedData.chequeNo : "",
      bankName: CopiedData.bankName ? CopiedData.bankName : "",
      vehicleNumber: CopiedData.vehicleNumber ? CopiedData.vehicleNumber : "",
      custName: CopiedData.custName ? CopiedData.custName : "",
      billAddr: CopiedData.billAddr ? CopiedData.billAddr : "",
      billEmail: CopiedData.billEmail ? CopiedData.billEmail : "",
      billContactNo: CopiedData.billContactNo ? CopiedData.billContactNo : "",
      billGSTNo: CopiedData.billGSTNo ? CopiedData.billGSTNo : "",
      billPANNo: CopiedData.billPANNo ? CopiedData.billPANNo : "",
      billState: CopiedData?.billState ? CopiedData?.billState : "",
      isSEZEnabled: CopiedData.isSEZEnabled ? CopiedData.isSEZEnabled : false,
      lutBondNo: CopiedData?.lutBondNo ? CopiedData?.lutBondNo : "",
      billCity: CopiedData?.billCity ? CopiedData?.billCity : "",
      billPincode: CopiedData?.billPincode ? CopiedData?.billPincode : "",
      shipCity: CopiedData?.shipCity ? CopiedData?.shipCity : "",
      shipPincode: CopiedData?.shipPincode ? CopiedData?.shipPincode : "",
    });

    if (CopiedData?.invoiceDetails) {
      setProductDetails([
        ...CopiedData?.invoiceDetails,
        {
          gst: 0,
          hsnId: 0,
          productId: 0,
          gstAmount: 0,
          igst: 0,
          igstAmount: 0,
          sgst: 0,
          sgstAmount: 0,
          cgst: 0,
          cgstAmount: 0,
          discPer: 0,
          discAmount: 0,
          unitId: 15,
          productName: "",
          hsnCode: "",
          qty: 0,
          rate: 0,
        },
      ]);
    }
  }, [CopiedData]);

  const [errMsg, setErrMsg] = useState({
    products: "",
  });

  const addNewRow = (e) => {
    e.preventDefault();
    let data = {
      gst: 0,
      gstAmount: 0,
      igst: 0,
      igstAmount: 0,
      sgst: 0,
      sgstAmount: 0,
      cgst: 0,
      cgstAmount: 0,
      discPer: 0,
      discAmount: 0,
      unitId: 15,
      productName: "",
      hsnId: 0,
      productId: 0,
      hsnCode: "",
      qty: 0,
      rate: 0,
    };

    let newdata = [...productDetails, data];
    setProductDetails(newdata);
  };
  useEffect(() => {
    // let state =
    //   states &&
    //   states.filter(
    //     (state, i) =>
    //       state.code == invoiceFormDetails.suppGSTNo?.substring(0, 2)
    //   )[0];

    simpleGetCallWithToken(ApiConfig.GET_STATES)
      .then((res) => {
        if (res.success) {
          simpleGetCallWithToken(ApiConfig.GET_PROFILE_DATA)
            .then((profileData) => {
              let supplierGstNumber = profileData.data.gstNo.substring(0, 2);
              let state =
                res.data &&
                res.data.filter(
                  (state, i) => state.code == supplierGstNumber
                )[0];
              if (invoiceAction !== "edit") {
                setInvoiceFormDetails({
                  ...invoiceFormDetails,
                  invoiceNo: "",
                  suppName: profileData.data.companyName,
                  suppAddr: profileData.data.address,
                  suppEmail: profileData.data.email,
                  suppContactNo: profileData.data.contactNo,
                  // suppContactNo: profileData.data.contactNo,
                  suppGSTNo: profileData.data.gstNo,
                  suppPANNo: profileData.data.panNo,
                  suppPincode: profileData.data.pincode,
                  invoiceDate: new Date().toISOString().toString(),
                  dueDate: new Date().toISOString().toString(),
                  subTotal: 0,
                  cgst: 0,
                  cgstAmount: 0,
                  sgst: 0,
                  sgstAmount: 0,
                  igst: 0,
                  igstAmount: 0,
                  placeOfSupply: `${state?.name}-${state?.code}`,
                  modeOfPay: "",
                  chequeNo: "",
                  bankName: "",
                  custName: "",
                  billAddr: "",
                  billState: "",
                  billCountry: "",
                  billEmail: "",
                  billContactNo: "",
                  billGSTNo: "",
                  billPANNo: "",
                  billCity: "",
                  billPincode: "",
                  shipCustName: "",
                  shipAddr: "",
                  shipState: "",
                  shipCountry: "",
                  shipContactNo: "",
                  shipGSTNo: "",
                  shipPANNo: "",
                  shipCity: "",
                  shipPincode: "",
                  shipPANNo: "",
                  grossAmount: 0,
                  gstAmount: 0,
                  totalAmount: 0,
                  PONo: "",
                  podate: null,
                  Ewaybill: "",
                  modeofTransport: "",
                  vehicleNumber: "",
                  isSEZEnabled: false,
                  lutBondNo: "",
                });
                setIsSezDeveloper(false);
                if (newInvoice || invGenerateState) {
                  setProductDetails([
                    {
                      ...productDetails,
                      gst: 0,
                      gstAmount: 0,
                      igst: 0,
                      igstAmount: 0,
                      sgst: 0,
                      sgstAmount: 0,
                      cgst: 0,
                      cgstAmount: 0,
                      discPer: 0,
                      discAmount: 0,
                      unitId: 15,
                      productName: "",
                      hsnId: 0,
                      hsnCode: "",
                      qty: 0,
                      rate: 0,
                    },
                  ]);
                }
                setValidated(false);
                getInvoiceNo();
              }
            })
            .catch((err) => {
              console.log("catch error,", err);
            });
        }
      })
      .catch((error) => {
        console.log("catch error res,", error);
      });
  }, [newInvoice, invGenerateState]);

  const goodsHandleChange = (name, event) => {
    setInvoiceFormDetails({
      ...invoiceFormDetails,
      [name]: event.target.value,
    });
  };

  const getSelectedInvoiceId = (selectedId) => {
    reciveInvoiceId(selectedId);
  };

  useEffect(() => {
    let totalAmount = 0;
    let subTotal = 0;
    let igstAmount = 0;
    let cgstAmount = 0;
    let sgstAmount = 0;
    productDetails &&
      productDetails.length &&
      productDetails.map((item) => {
        igstAmount = igstAmount + item.igstAmount;
        cgstAmount = cgstAmount + item.cgstAmount;
        sgstAmount = sgstAmount + item.sgstAmount;
        subTotal = subTotal + item.discAmount;
        totalAmount =
          !isStateSame || invoiceFormDetails?.isSEZEnabled
            ? totalAmount + item.discAmount + item.igstAmount
            : totalAmount + item.discAmount + item.cgstAmount + item.sgstAmount;
        // : totalAmount + item.discAmount + item.igstAmount
      });

    setInvoiceFormDetails({
      ...invoiceFormDetails,
      totalAmount: Math.floor(toFixedValue(totalAmount)),
      subTotal: toFixedValue(subTotal),
      igstAmount: toFixedValue(igstAmount),
      cgstAmount: toFixedValue(cgstAmount),
      sgstAmount: toFixedValue(sgstAmount),
      roundOff: appSettings.isRoundOff ? Number(roundedOff(totalAmount)) : 0,
    });
  }, [productDetails]);

  const DeleteHandler = (index) => {
    const productList = [...productDetails];
    productList.splice(index, 1);
    setProductDetails(productList);
  };
  const [isSezDeveloper, setIsSezDeveloper] = useState(false);
  const getDetailsByGstNumber = (gstNumber, gstType) => {
    if (gstNumber.length === 15) {
      setBackDropOpen(false);
      simpleGetCallWithToken(
        ApiConfig.GET_GSTIN_DETAILS + `/${gstNumber.toUpperCase()}`
      )
        .then((res) => {
          setBackDropOpen(false);
          let gstDetail = res.data.lstAppSCommonSearchTPResponse[0];
          setIsSezDeveloper(gstDetail?.dty === "SEZ Developer" ? true : false);
          let address =
            gstDetail.pradr.addr.flno +
            "," +
            " " +
            gstDetail.pradr.addr.bno +
            "," +
            " " +
            gstDetail.pradr.addr.bnm +
            "," +
            " " +
            gstDetail.pradr.addr.st +
            "," +
            " " +
            gstDetail.pradr.addr.loc +
            "," +
            " " +
            gstDetail.pradr.addr.stcd;
          if (gstType === "shipGSTNumber") {
            setInvoiceFormDetails({
              ...invoiceFormDetails,
              shipCustName: gstDetail.tradeNam,
              shipAddr: address,
              shipGSTNo: gstDetail.gstin,
              shipPANNo: gstDetail.gstin.substring(2, 12),
              shipPincode: gstDetail.pradr.addr.pncd,
            });
          } else {
            let state =
              states &&
              states.filter(
                (state, i) => state.code == gstDetail.gstin.substring(0, 2)
              )[0];
            setInvoiceFormDetails({
              ...invoiceFormDetails,
              custName: gstDetail.tradeNam,
              billAddr: address,
              billGSTNo: gstDetail.gstin,
              billPANNo: gstDetail.gstin.substring(2, 12),
              //placeOfSupply: `${state.name}-${state.code}`,
              billPincode: gstDetail.pradr.addr.pncd,
              billCity: gstDetail.pradr.addr.loc,

              isSEZEnabled: gstDetail?.dty === "SEZ Developer" ? true : false,
            });
          }
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <main>
      {/* <BackDropLoader
        backDropOpen={backDropOpen}
        setBackDropOpen={setBackDropOpen}
      /> */}
      <Form
        noValidate
        validated={validated}
        onSubmit={invoiceAction === "edit" ? updateInvoice : saveInvoiceForm}
      >
        <div id="main-default-edit-form">
          <div className="main-invoice-card">
            <div className="invoice-inner-main">
              {/* ========================================================== */}
              <div className="text-invoice-main">
                {formFormat === "center" && (
                  <div className="middle-top-logo text-center pb-3 mt-4">
                    <div className="right-logo logo-back">
                      {/* <div className="img-right img">
                        <img src={rb_logo} alt="" />
                      </div> */}
                      <div style={{ textAlign: "center" }}>
                        {/* <input
                          type="file"
                          name=""
                          id="uploadLogo1"
                          className="d-none"
                        /> */}

                        {Dark === "lightMode" ? (
                          <img
                            src={userData?.CompanyLogo}
                            alt=""
                            onError={(e) => e.target.src = Logo}

                          />
                        ) : (
                          <img
                            src={userData?.CompanyLogo}
                            alt=""
                            onError={(e) => e.target.src = Logo}
                          />

                        )}

                        {/* <br />
                        <label
                          style={{ fontSize: "11px" }}
                          htmlFor=""
                          className="text-auth"
                        >
                          Upload your logo here
                        </label> */}
                      </div>
                    </div>
                  </div>
                )}
                <div className="text-invoice-inner">
                  {formFormat === "left" && (
                    <div className="right-logo logo-back">
                      {/* <div className="img-right img">
                        <img src={rb_logo} alt="" />
                      </div> */}
                      <div style={{ textAlign: "center" }}>
                        {/* <input
                          type="file"
                          name=""
                          id="uploadLogo1"
                          className="d-none"
                        /> */}
                        {Dark === "lightMode" ? (
                          <img
                            src={userData?.CompanyLogo}
                            alt=""
                            onError={(e) => e.target.src = Logo}
                          />
                        ) : (
                          <img
                            src={userData?.CompanyLogo}
                            alt=""
                            onError={(e) => e.target.src = Logo}
                          />
                        )}

                        {/* <br />
                        <label
                          style={{ fontSize: "11px" }}
                          htmlFor=""
                          className="text-auth"
                        >
                          Upload your logo here
                        </label> */}
                      </div>
                    </div>
                  )}

                  <div className="right">
                    <div className="invoice-text-right">
                      <div className="text-invoice-heading">
                        <label htmlFor="">Tax Invoice</label>
                      </div>
                      <div className="invoice-number">
                        <label htmlFor="" className="key">
                          Invoice No.
                        </label>
                        <label htmlFor="" className="value ms-4">
                          {invoiceFormDetails?.invoiceNo
                            ? invoiceFormDetails?.invoiceNo
                            : invoiceNo}
                        </label>
                        {/* <div className="input-with-pencile">
                          <input
                            name="invoiceNo"
                            type="text"
                            className="form-control mb-1 invoice-number-style"
                            value={invoiceFormDetails.invoiceNo}
                            placeholder="Invoice Number"
                            required
                            onChange={(e) => {
                              goodsHandleChange("invoiceNo", e);
                              setInvoiceNo(e.target.value)
                            }}
                          />
                          <img className="pen" src={ic_green_pen} alt="" />
                          <div className="invalid-feedback font-11">
                            Please Enter Invoice Number
                          </div>
                        </div> */}
                      </div>
                      <div className="date">
                        <div>
                          <label htmlFor="" className="key">
                            Date:{" "}
                          </label>
                        </div>

                        {/* <label htmlFor="date" className="value date-input">
                        <img src={ic_calender} alt="" />
                      </label> */}

                        <div className="d-flex ">
                          <DatePicker
                            selected={invoiceDate}
                            value={
                              invoiceFormDetails.invoiceDate
                                ? displayDateFormat(
                                  appSettings.dateFormat,
                                  invoiceFormDetails.invoiceDate
                                )
                                : ""
                            }
                            onChange={(date) => {
                              setInvoiceDate(date);
                              setInvoiceFormDetails({
                                ...invoiceFormDetails,
                                invoiceDate: new Date(date)
                                  .toISOString()
                                  .toString(),
                              });
                            }}
                            showYearDropdown
                            // dateFormat="dd/MM/yyyy"
                            name="invoiceDate"
                            placeholderText="Choose a date"
                            className="cald form-control form-control-date ms-2"
                          />
                          {Dark === "lightMode" ? (
                            <img
                              src={calendersvg}
                              className="calendarI"
                              alt=""
                            />
                          ) : (
                            <img
                              src={calendersvg_dark}
                              className="calendarI"
                              alt=""
                            />
                          )}

                          {/* <img
                            src={ic_green_pen}
                            alt=""
                            className="pen-img ms-2"
                            id="pen-img"
                          /> */}
                        </div>
                      </div>

                      <div className="date" id="deu-date">
                        <div>
                          <label htmlFor="" className="key">
                            Due Date:{" "}
                          </label>
                        </div>

                        {/* <label htmlFor="date" className="value date-input">
                        <img src={ic_calender} alt="" />
                      </label> */}

                        <div className="d-flex ">
                          <DatePicker
                            selected={selectedDueDate}
                            value={
                              invoiceFormDetails.dueDate
                                ? displayDateFormat(
                                  appSettings.dateFormat,
                                  invoiceFormDetails.dueDate
                                )
                                : ""
                            }
                            onChange={(date) => {
                              setSelectedDueDate(date);
                              setInvoiceFormDetails({
                                ...invoiceFormDetails,
                                dueDate: new Date(date)
                                  .toISOString()
                                  .toString(),
                              });
                            }}
                            showYearDropdown
                            // minDate={new Date(invoiceDate)}
                            // dateFormat="dd/MM/yyyy"
                            placeholderText="Choose a date"
                            className="cald form-control form-control-date ms-2"
                          />
                          {Dark === "lightMode" ? (
                            <img
                              src={calendersvg}
                              className="calendarI"
                              alt=""
                            />
                          ) : (
                            <img
                              src={calendersvg_dark}
                              className="calendarI"
                              alt=""
                            />
                          )}{" "}
                          {/* <img
                            src={ic_green_pen}
                            alt=""
                            className="pen-img ms-2"
                            id="pen-img"
                          /> */}
                        </div>
                      </div>
                      {/* <div className="date" id="deu-date">
                        <label htmlFor="" className="key">
                          Payment Terms:
                        </label>
                        <div className="d-flex align-items-center">
                          <select
                            id="paymentTerms"
                            className="cald form-control form-control-date ms-2"
                            aria-label="Default select example"
                            name="paymentTerms"
                           // value={invoiceFormDetails.paymentTerms}
                            required
                           
                            onChange={(e) => {
                              const values = JSON.parse(e.target.value);
                              console.log("value,", values.days);
                            
                              const { payTerms, id } = values;
                            
                              // Assuming payTerms is a number representing the days
                              const paymentTermDays = parseInt(payTerms, 10);
                            
                              // Assuming invoiceDate is a Date object or a string that can be converted to a Date object
                              const invoiceDate = new Date(invoiceFormDetails.invoiceDate);
                            
                              // Calculate the due date by adding the payment term days
                              const dueDate = new Date(invoiceDate);
                              dueDate.setDate(dueDate.getDate() + paymentTermDays);
                            
                              setInvoiceFormDetails({
                                ...invoiceFormDetails,
                                paymentTermId: values.id,
                                paymentTerms: values.payTerms,
                                dueDate: dueDate.toISOString().split('T')[0]  // format as YYYY-MM-DD
                              });
                            }}
                            
                          >
                            <option value="">Open this select menu</option>
                            {paymentTerms.map((item, i) => {
                              return (
                                <option value={JSON.stringify(item)}>
                                  {item.payTerms}
                                </option>
                              );
                            })}
                          </select>
                          {/* <img className="pen" src={ic_green_pen} alt="" /> 
                          <div className="invalid-feedback font-11">
                            Please Select Payment Terms
                          </div>
                        </div> 
                        
                          </div>
                      */}
                      <div className="date" id="deu-date">
                        <label htmlFor="" className="key">
                          Payment Terms:
                        </label>
                        <div className="d-flex align-items-center">
                          <select
                            id="paymentTerms"
                            className="cald form-control form-control-date ms-2"
                            aria-label="Default select example"
                            name="paymentTerms"
                            value={invoiceFormDetails.paymentTermId || ""}
                            required
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              const selectedOption = paymentTerms.find(
                                (item) => item.id.toString() === selectedId
                              );

                              if (selectedOption) {
                                const { payTerms, id } = selectedOption;
                                const paymentTermDays = parseInt(payTerms, 10);
                                const invoiceDate = new Date(
                                  invoiceFormDetails.invoiceDate
                                );
                                const dueDate = new Date(invoiceDate);
                                dueDate.setDate(
                                  dueDate.getDate() + paymentTermDays
                                );

                                setInvoiceFormDetails({
                                  ...invoiceFormDetails,
                                  paymentTermId: id,
                                  paymentTerms: payTerms,
                                  dueDate: dueDate.toISOString().split("T")[0], // format as YYYY-MM-DD
                                });
                              }
                            }}
                          >
                            <option value="">Open this select menu</option>
                            {paymentTerms.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.payTerms}
                              </option>
                            ))}
                          </select>
                          <div className="invalid-feedback font-11">
                            Please Select Payment Terms
                          </div>
                        </div>
                      </div>

                      <div className="deu-date"></div>
                    </div>
                  </div>
                  {formFormat === "right" && (
                    <div className="right-logo logo-back">
                      {/* <div className="img-right img">
                        <img src={rb_logo} alt="" />
                      </div> */}
                      <div style={{ textAlign: "center" }}>
                        {/* <input
                          type="file"
                          name=""
                          id="uploadLogo1"
                          className="d-none"
                        /> */}
                        {Dark === "lightMode" ? (
                          <img
                            src={userData?.CompanyLogo}
                            alt=""
                            onError={(e) => e.target.src = Logo}
                          />
                        ) : (
                          <img
                            src={userData?.CompanyLogo}
                            alt=""
                            onError={(e) => e.target.src = Logo}
                          />
                        )}
                        {/* <br />
                        <label
                          style={{ fontSize: "11px" }}
                          htmlFor=""
                          className="text-auth"
                        >
                          Upload your logo here
                        </label> */}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* ========================================================== */}
              <div className="name-details-main">
                <div className="name-details-inner ">
                  <div className="left">
                    {/* owner detail */}
                    <div className="left-input-info">
                      <input
                        type="text"
                        name="suppName"
                        className="form-control mb-1"
                        id="name"
                        value={invoiceFormDetails.suppName}
                        style={{ border: "none", width: "260px" }}
                        disabled
                      />
                      <textarea
                        name="suppAddr"
                        id="text-area"
                        cols="30"
                        rows="10"
                        className="form-control mb-1"
                        placeholder="Address"
                        value={invoiceFormDetails.suppAddr}
                        style={{ border: "none", width: "auto" }}
                        disabled
                      ></textarea>

                      <div className="contact" style={{ width: "280px" }}>
                        <label htmlFor="">Email Id </label>
                        <input
                          type="text"
                          name="suppContactNo"
                          className="form-control mb-1"
                          value={invoiceFormDetails.suppEmail}
                          style={{ border: "none", width: "224px" }}
                          disabled
                        />
                      </div>

                      <div className="contact">
                        <label htmlFor="">Contact No.</label>
                        <input
                          type="text"
                          name="suppContactNo"
                          className="form-control mb-1"
                          maxLength={10}
                          value={invoiceFormDetails.suppContactNo}
                          style={{ border: "none" }}
                          disabled
                        />
                      </div>
                      {appSettings && appSettings.isGSTApplicable && (
                        <div className="contact mb-1">
                          <label htmlFor="">GST No.</label>
                          <input
                            type="text"
                            name="suppGSTNo"
                            className="form-control"
                            placeholder="XX-XXXXXXXXXX-XXX"
                            value={invoiceFormDetails.suppGSTNo}
                            style={{ border: "none" }}
                            disabled
                          />
                        </div>
                      )}
                      <div className="contact mb-1">
                        <label htmlFor="">PAN No.</label>
                        <input
                          type="text"
                          name="suppPANNo"
                          className="form-control"
                          placeholder="XXXXXXXXXX"
                          value={invoiceFormDetails.suppPANNo}
                          style={{ border: "none" }}
                          disabled
                        />
                      </div>
                      <div className="mt-2 PON_No">
                        <label htmlFor="" className="key marginttop4 ">
                          P.O No.
                        </label>
                        <div className="input-with-pencile">
                          <input
                            type="text"
                            className="form-control mb-1"
                            placeholder=""
                            value={invoiceFormDetails.PONo}
                            onChange={(e) => {
                              goodsHandleChange("PONo", e);
                            }}
                          />
                          {/* <img className="pen" src={ic_green_pen} alt="" /> */}
                        </div>
                      </div>

                      <div className="contact mb-1 PON_No">
                        <label htmlFor="" className="date-owener">
                          Date:
                        </label>
                        <div className="d-flex calender-owener">
                          <DatePicker
                            selected={
                              invoiceFormDetails.podate
                                ? new Date(invoiceFormDetails.podate)
                                : new Date()
                            }
                            // required
                            value={
                              invoiceFormDetails.podate
                                ? displayDateFormat(
                                  appSettings.dateFormat,
                                  invoiceFormDetails.podate
                                )
                                : ""
                            }
                            onChange={(date) => {
                              setPodate(date);
                              setInvoiceFormDetails({
                                ...invoiceFormDetails,
                                podate: new Date(date).toISOString().toString(),
                              });
                            }}
                            showYearDropdown
                            // minDate={new Date(invoiceDate)}
                            // dateFormat="dd/MM/yyyy"
                            placeholderText="Choose a date"
                            className="cald form-control form-control-date ms-2"
                          />
                          {Dark === "lightMode" ? (
                            <img
                              src={calendersvg}
                              className="calendarI"
                              alt=""
                            />
                          ) : (
                            <img
                              src={calendersvg_dark}
                              className="calendarI"
                              alt=""
                            />
                          )}{" "}
                          {/* <img
                            src={ic_green_pen}
                            alt=""
                            className="pen-img ms-2"
                            id="pen-img"
                          /> */}
                        </div>
                      </div>

                      {/* E-Way Bill No */}
                      {/* <div className="mb-2 mt-2 PON_No">
                        <label htmlFor="" className="key marginttop4 ">
                          E-Way Bill No
                        </label>
                        <div className="input-with-pencile">
                          <input
                            disabled
                            type="text"
                            className="form-control mb-1"
                            placeholder="1234567890"
                            // required
                            value={invoiceFormDetails.Ewaybill}
                            onChange={(e) => {
                              goodsHandleChange("Ewaybill", e);
                            }}
                          />
                          <img className="pen" src={ic_green_pen} alt="" />
                          <div className="invalid-feedback font-11">
                            Please Select E-Way Bill Number
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                  <div className="right">
                    <div className="place-text-right">
                      <div className="mb-4">
                        <label htmlFor="" className="key">
                          Place of Supply :
                        </label>
                        <div className="input-with-pencile">
                          <select
                            id="placeOfSupply"
                            className="form-select"
                            aria-label="Default select example"
                            name="placeOfSupply"
                            required
                            disabled={
                              invoiceFormDetails.billGSTNo ||
                                invoiceFormDetails.billState
                                ? true
                                : false
                            }
                            value={invoiceFormDetails.placeOfSupply}
                            onChange={(e) => {
                              goodsHandleChange("placeOfSupply", e);
                            }}
                          >
                            <option value={""}>Open this select menu</option>
                            {states &&
                              states.map((state) => (
                                <option
                                  value={`${state.name}-${state.code}`}
                                >{`${state.name}-${state.code}`}</option>
                              ))}
                          </select>
                          {/* <img className="pen" src={ic_green_pen} alt="" /> */}
                          <div className="invalid-feedback font-11">
                            Please Select Place Of Supply
                          </div>
                        </div>
                      </div>
                      <div className="">
                        <label htmlFor="" className="key">
                          Mode of Payment:
                        </label>
                        <div className="input-with-pencile mb-1">
                          <select
                            id="modeOfPay"
                            className="form-select"
                            aria-label="Default select example"
                            name="modeOfPay"
                            required
                            value={invoiceFormDetails.modeOfPay}
                            onChange={(e) => {
                              goodsHandleChange("modeOfPay", e);
                            }}
                          >
                            <option value="">Open this select menu</option>
                            <option value="Cash">Cash</option>
                            <option value="Credit">Credit</option>
                            <option value="Online">Online</option>
                            <option value="Cheque">Cheque</option>
                          </select>
                          {/* <img className="pen" src={ic_green_pen} alt="" /> */}
                          <div className="invalid-feedback font-11">
                            Please Select Mode Of Payment
                          </div>
                        </div>
                      </div>

                      <div className="input-with-pencile mb-1">
                        {invoiceFormDetails.modeOfPay === "Cheque" ? (
                          <>
                            <input
                              id="chequeNo"
                              type="text"
                              name="chequeNo"
                              className="form-control"
                              placeholder="Cheque No. XXX06542"
                              required={
                                invoiceFormDetails.modeOfPay === "Cheque"
                                  ? true
                                  : false
                              }
                              value={invoiceFormDetails.chequeNo}
                              onChange={(e) => {
                                goodsHandleChange("chequeNo", e);
                              }}
                            />

                            <img className="pen" src={ic_green_pen} alt="" />
                            <div className="invalid-feedback font-11">
                              Please provide Cheque No.
                            </div>
                          </>
                        ) : null}
                      </div>

                      <div className="input-with-pencile mb-1">
                        {invoiceFormDetails.modeOfPay === "Cheque" ? (
                          <>
                            <input
                              id="bankName"
                              type="text"
                              name="bankName"
                              className="form-control"
                              placeholder="Name of Bank"
                              required={
                                invoiceFormDetails.modeOfPay === "Cheque"
                                  ? true
                                  : false
                              }
                              value={invoiceFormDetails.bankName}
                              onChange={(e) => {
                                goodsHandleChange("bankName", e);
                              }}
                            />

                            <img className="pen" src={ic_green_pen} alt="" />
                            <div className="invalid-feedback font-11">
                              Please provide Bank Name
                            </div>
                          </>
                        ) : null}
                      </div>

                      {/* <div className="marginttop4 mt-2">
                        <label htmlFor="" className="key">
                          Mode of Transport
                        </label>
                        <div className="input-with-pencile mb-1">
                          <select
                            disabled
                            className="form-select"
                            aria-label="Default select example"
                            name="modeofTransport"
                            value={invoiceFormDetails.modeofTransport}
                            onChange={(e) => {
                              goodsHandleChange("modeofTransport", e);
                            }}
                          >
                            <option value="">Transport type...</option>
                            <option value="By Road">By Road</option>
                            <option value="By Air">By Air</option>
                            <option value="By Train">By Train</option>
                          </select>
                          <img className="pen" src={ic_green_pen} alt="" />
                          <div className="invalid-feedback font-11">
                            Please provide Mode Of Transport
                          </div>
                        </div>
                      </div> */}

                      {invoiceFormDetails.modeofTransport === "By Road" && (
                        <div className="input-with-pencile mb-1">
                          <input
                            name="vehicleNumber"
                            type="text"
                            className="form-control"
                            placeholder="Vehicle Number"
                            required
                            value={invoiceFormDetails.vehicleNumber}
                            onChange={(e) => {
                              goodsHandleChange("vehicleNumber", e);
                            }}
                          />

                          <img className="pen" src={ic_green_pen} alt="" />
                          <div className="invalid-feedback font-11">
                            Please provide plate No.
                          </div>
                        </div>
                      )}
                      {/* isSezDeveloper */}
                      {isSezDeveloper && (
                        <div className="marginttop4 mt-2 d-flex">
                          <input
                            type="checkbox"
                            style={{ marginRight: "7px", width: "11px" }}
                            checked={invoiceFormDetails?.isSEZEnabled}
                            onChange={(e) => {
                              setInvoiceFormDetails({
                                ...invoiceFormDetails,
                                isSEZEnabled: e.target.checked,
                              });
                              setProductDetails(
                                productDetails &&
                                productDetails.map((item, i) => {
                                  return {
                                    ...item,
                                    igst: 0,
                                    igstAmount: 0,
                                    sgst: 0,
                                    sgstAmount: 0,
                                    cgst: 0,
                                    cgstAmount: 0,
                                  };
                                })
                              );
                            }}
                          />
                          <label htmlFor="" className="key">
                            Enable SEZ
                          </label>
                        </div>
                      )}
                      {invoiceFormDetails?.isSEZEnabled && (
                        <div className="mt-2 PON_No">
                          <label htmlFor="" className="key marginttop4 ">
                            LUT Bond No
                          </label>
                          <div className="input-with-pencile">
                            <input
                              id="lutBondNo"
                              type="text"
                              className="form-control mb-1"
                              value={invoiceFormDetails.lutBondNo}
                              placeholder=""
                              onChange={(e) => {
                                goodsHandleChange("lutBondNo", e);
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="name-details-main" id="info">
                <div className="name-details-inner">
                  <div className=" left " id="left">
                    <div className="name">
                      <label htmlFor="" id="small-heading">
                        Bill To 
                      </label>
                    </div>
                    <div className="left-input-info">
                      <div className="input-with-pencile">
                        <input
                          id="custName"
                          list="customerNames"
                          type="text"
                          className="form-control mb-1 me-2"
                          placeholder="Name"
                          name="custName"
                          required
                          value={invoiceFormDetails.custName}
                          // taleeb
                          onChange={(e) => {
                            goodsHandleChange("custName", e);
                            // let billNames = nameList.filter((item, index) => {
                            //   if (item.customerName === e.target.value) {
                            //     return item;
                            //   }
                            // })[0]; /* old one, i replace it with new one below */
                            let billNames = clientList?.filter((item, index) => {
                              if (item.firstName === e.target.value) {
                                return item;
                              }
                            })[0];
                         
                            billNames && getCustomerBillingData(billNames);
                          }}
                        />{" "}
                   
                      
                        {/* <datalist
                          id="customerNames"
                          className="datalist-product"
                        >
                          {nameList &&
                            nameList.map((item) => {
                              return (
                                <>
                                  <option>{item.customerName}</option>
                                </>
                              );
                            })}
                        </datalist> */} {/* old one with customer name, i replace it with new client name */}
                         <datalist
                          id="customerNames"
                          className="datalist-product"
                        >
                          {clientList &&
                            clientList.map((item) => {
                              return (
                                <>
                                  <option>{item.firstName}</option>
                                </>
                              );
                            })}
                        </datalist>
                       
                        {/* <img className="pen" src={ic_green_pen} alt="" /> */}
                        <div className="invalid-feedback font-11">
                          Please provide Name
                        </div>
                      </div>

                      <div className="input-with-pencile">
                        <textarea
                          id="billAddr"
                          name="billAddr"
                          cols="30"
                          rows="10"
                          className="form-control mb-1  me-2"
                          placeholder="Address"
                          required
                          value={invoiceFormDetails.billAddr}
                          onChange={(e) => {
                            goodsHandleChange("billAddr", e);
                          }}
                          style={{ height: "60px", resize: "none" }}
                        />
                        {/* <img className="pen" src={ic_green_pen} alt="" /> */}
                        <div className="invalid-feedback font-11">
                          Please provide Address
                        </div>
                      </div>
                      <div className="contact input-with-pencile_1 mb-1">
                        <label htmlFor="">City</label>
                        <div className="">
                          <input
                            id="billCity"
                            type="text"
                            name="billCity"
                            className="form-control mb-1 me-2"
                            value={invoiceFormDetails.billCity}
                            onChange={(e) => {
                              goodsHandleChange("billCity", e);
                            }}
                          />
                        </div>
                      </div>
                      <div className="contact input-with-pencile_1 mb-1">
                        <label htmlFor="">Pin</label>
                        <div className="">
                          <input
                            id="billPincode"
                            type="text"
                            name="billPincode"
                            className="form-control mb-1 me-2"
                            value={invoiceFormDetails.billPincode}
                            onChange={(e) => {
                              goodsHandleChange("billPincode", e);
                            }}
                          />
                        </div>
                      </div>
                      <div className="contact input-with-pencile_1 mb-1">
                        <label htmlFor="">Email Id </label>
                        <div className="">
                          <input
                            id="billEmail"
                            type="email"
                            name="billEmail"
                            required
                            className="form-control mb-1 me-2"
                            value={invoiceFormDetails.billEmail}
                            // required
                            onChange={(e) => {
                              goodsHandleChange("billEmail", e);
                            }}
                          />

                          {/* <img className="pen_1" src={ic_green_pen} alt="" /> */}
                          <div className="invalid-feedback font-11">
                            Please enter valid email Id
                          </div>
                        </div>
                      </div>

                      <div className="contact input-with-pencile_1 mb-1">
                        <label htmlFor="">Contact No. </label>
                        <div className="">
                          <input
                            id="billContactNo"
                            type="text"
                            maxLength={10}
                            name="billContactNo"
                            className="form-control mb-1 me-2"
                            required
                            value={invoiceFormDetails.billContactNo}
                            onChange={(e) => {
                              const regex = /^[0-9 +\b]+$/;
                              if (
                                e.target.value == "" ||
                                regex.test(e.target.value)
                              ) {
                                goodsHandleChange("billContactNo", e);
                              }
                            }}
                          />

                          {/* <img className="pen_1" src={ic_green_pen} alt="" /> */}
                          <div className="invalid-feedback font-11">
                            Please provide Contact
                          </div>
                        </div>
                      </div>
                      {appSettings && appSettings.isGSTApplicable && (
                        <div className="contact input-with-pencile_1 mb-1">
                          <label htmlFor="">GST No.</label>
                          <div className="">
                            {" "}
                            <input
                              id="billGSTNo"
                              type="text"
                              name="billGSTNo"
                              maxLength={15}
                              className="form-control me-2"
                              placeholder="XX-XXXXXXXXXX"
                              // required
                              value={invoiceFormDetails.billGSTNo}
                              onChange={(e) => {
                                handleInvoiceSearch(e);
                                // goodsHandleChange("billGSTNo", e);
                                setInvoiceFormDetails({
                                  ...invoiceFormDetails,
                                  billGSTNo: e.target.value.toUpperCase(),
                                  billState: "",
                                });
                                getDetailsByGstNumber(e.target.value);
                              }}
                            />
                            {/* <img className="pen_1" src={ic_green_pen} alt="" /> */}
                            <div className="invalid-feedback font-11">
                              Please provide GST No.
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="contact input-with-pencile_1 mb-1">
                        <label htmlFor="">PAN No.</label>
                        <div className="">
                          <input
                            id="billPANNo"
                            type="text"
                            name="billPANNo"
                            className="form-control me-2"
                            placeholder="XXXXXXXXXX"
                            // required
                            value={invoiceFormDetails.billPANNo}
                            onChange={(e) => {
                              goodsHandleChange("billPANNo", e);
                            }}
                          />
                          {/* <img className="pen_1" src={ic_green_pen} alt="" /> */}
                          <div className="invalid-feedback font-11">
                            Please provide PAN No.
                          </div>
                        </div>
                      </div>

                      {invoiceFormDetails.billGSTNo === "" && (
                        <div className="contact input-with-pencile_1 mb-1">
                          <label htmlFor="">State</label>
                          <div className="input-with-pencile">
                            <select
                              style={{ width: "150px", marginRight: "8px" }}
                              // id="placeOfSupply"
                              className="form-select"
                              aria-label="Default select example"
                              name="billState"
                              value={invoiceFormDetails.billState}
                              onChange={(e) => {
                                setInvoiceFormDetails({
                                  ...invoiceFormDetails,
                                  billState: e.target.value,
                                  // placeOfSupply: e.target.value,
                                });
                              }}
                            >
                              <option value="">Select state</option>
                              {states &&
                                states.map((state) => (
                                  <option
                                    value={`${state.name}-${state.code}`}
                                  >{`${state.name}-${state.code}`}</option>
                                ))}
                            </select>
                            {/* <img className="pen" src={ic_green_pen} alt="" /> */}
                            {/* <div className="invalid-feedback font-11">
                                  Please Select Place Of Supply
                                </div> */}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Ship To detaila */}
                  {/* <div className=" left " id="left">
                    <div className="name">
                      <label
                        htmlFor=""
                        id="small-heading"
                        className="marginttop4"
                      >
                        Ship To,
                      </label>
                    </div>
                    <div className="left-input-info">
                      <div className="input-with-pencile">
                        <input
                          id="shipCustName"
                          type="text"
                          name="shipCustName"
                          className="form-control mb-1 me-2"
                          placeholder="Name"
                          required
                          value={invoiceFormDetails.shipCustName}
                          onChange={(e) => {
                            goodsHandleChange("shipCustName", e);
                          }}
                        />{" "}
                        <img className="pen" src={ic_green_pen} alt="" />
                        <div className="invalid-feedback font-11">
                          Please provide Name
                        </div>
                      </div>

                      <div className="input-with-pencile">
                        <textarea
                          id="shipAddr"
                          name="shipAddr"
                          cols="30"
                          rows="10"
                          required
                          className="form-control mb-1  me-2"
                          placeholder="Address"
                          value={invoiceFormDetails.shipAddr}
                          onChange={(e) => {
                            goodsHandleChange("shipAddr", e);
                          }}
                          style={{ height: "60px", resize: "none" }}
                        />
                        <img className="pen" src={ic_green_pen} alt="" />

                        <div className="invalid-feedback font-11">
                          Please provide Address
                        </div>
                      </div>

                      <div className="contact input-with-pencile_1 mb-1">
                        <label htmlFor="">Contact No. </label>
                        <div className="">
                          <input
                            id="shipContactNo"
                            type="text"
                            maxLength={20}
                            name="shipContactNo"
                            className="form-control mb-1 me-2"
                            value={invoiceFormDetails.shipContactNo}
                            required
                            onChange={(e) => {
                              const regex = /^[0-9\b]+$/;
                              if (
                                e.target.value === "" ||
                                regex.test(e.target.value)
                              ) {
                                goodsHandleChange("shipContactNo", e);
                              }
                            }}
                          />
                          <img className="pen_1" src={ic_green_pen} alt="" />
                          <div className="invalid-feedback font-11">
                            Please provide Contact
                          </div>
                        </div>
                      </div>

                      <div className="contact input-with-pencile_1 mb-1">
                        <label htmlFor="">GST No.</label>
                        <div className="">
                          {" "}
                          <input
                            id="shipGSTNo"
                            type="text"
                            name="shipGSTNo"
                            className="form-control me-2"
                            placeholder="XX-XXXXXXXXXX"
                            required
                            value={invoiceFormDetails.shipGSTNo}
                            onChange={(e) => {
                              handleInvoiceSearch(e);
                              goodsHandleChange("shipGSTNo", e);
                              getDetailsByGstNumber(
                                e.target.value,
                                "shipGSTNumber"
                              );
                            }}
                          />
                          <img className="pen_1" src={ic_green_pen} alt="" />
                          <div className="invalid-feedback font-11">
                            Please provide GST No.
                          </div>
                        </div>
                      </div>

                      <div className="contact input-with-pencile_1 mb-1">
                        <label htmlFor="">PAN No.</label>
                        <div className="">
                          <input
                            id="shipPANNo"
                            type="text"
                            name="shipPANNo"
                            className="form-control me-2"
                            placeholder="XXXXXXXXXX"
                            required
                            value={invoiceFormDetails.shipPANNo}
                            onChange={(e) => {
                              goodsHandleChange("shipPANNo", e);
                            }}
                          />
                          <img className="pen_1" src={ic_green_pen} alt="" />
                          <div className="invalid-feedback font-11">
                            Please provide PAN No.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>

              <div className="detail-table-main">
                <ProductTable
                  isStateSame={isStateSame}
                  productDetails={productDetails}
                  setProductDetails={setProductDetails}
                  units={units}
                  addNewRow={addNewRow}
                  setBackDropOpen={setBackDropOpen}
                  errMsg={errMsg}
                  permissions={permissions}
                  setErrMsg={setErrMsg}
                  DeleteHandler={DeleteHandler}
                  currentRoute={currentRoute}
                  appSettings={appSettings}
                  invoiceFormDetails={invoiceFormDetails}
                />
              </div>
              <div className="sub-total-section">
                <div className="left">
                  <div className="text-sub">
                    <label htmlFor="">Sub Total</label>
                  </div>
                  {appSettings &&
                    appSettings?.isGSTApplicable &&
                    (!isStateSame || invoiceFormDetails?.isSEZEnabled) ? (
                    <div className="text-sub">
                      <label htmlFor="">IGST</label>
                    </div>
                  ) : (
                    <>
                      {appSettings && appSettings.isGSTApplicable && (
                        <div className="text-sub">
                          <label htmlFor="">CGST</label>
                        </div>
                      )}
                      {appSettings && appSettings.isGSTApplicable && (
                        <div className="text-sub">
                          <label htmlFor="">SGST</label>
                        </div>
                      )}
                    </>
                  )}
                  {appSettings && appSettings.isRoundOff && (
                    <div className="text-sub">
                      <label htmlFor="">Round off</label>
                    </div>
                  )}
                </div>
                <div className="right">
                  <div className="sub-total">
                    <label htmlFor="">
                      ₹
                      {invoiceFormDetails.subTotal
                        ? parseFloat(invoiceFormDetails.subTotal).toFixed(2)
                        : 0}
                    </label>
                  </div>
                  {appSettings &&
                    appSettings?.isGSTApplicable &&
                    (!isStateSame || invoiceFormDetails?.isSEZEnabled) ? (
                    <div className="sub-total">
                      <label htmlFor="">
                        ₹
                        {invoiceFormDetails.igstAmount
                          ? parseFloat(invoiceFormDetails.igstAmount).toFixed(2)
                          : 0}
                      </label>
                    </div>
                  ) : (
                    <>
                      {appSettings && appSettings.isGSTApplicable && (
                        <div className="sub-total">
                          <label htmlFor="">
                            ₹
                            {invoiceFormDetails.cgstAmount
                              ? parseFloat(
                                invoiceFormDetails.cgstAmount
                              ).toFixed(2)
                              : 0}
                          </label>
                        </div>
                      )}
                      {appSettings && appSettings.isGSTApplicable && (
                        <div className="sub-total">
                          <label htmlFor="">
                            ₹
                            {invoiceFormDetails.sgstAmount
                              ? parseFloat(
                                invoiceFormDetails.sgstAmount
                              ).toFixed(2)
                              : 0}
                          </label>
                        </div>
                      )}
                    </>
                  )}
                  {appSettings && appSettings.isRoundOff && (
                    <div className="sub-total">
                      <label htmlFor="">
                        {invoiceFormDetails.roundOff
                          ? invoiceFormDetails.roundOff
                          : 0}
                      </label>
                    </div>
                  )}
                </div>
              </div>
              <div className="mainsub-total"></div>
              <div className="total-amt-main">
                <div className="sub-total-section" id="sub-total-section">
                  <div className="left">
                    <div className="text-sub">
                      <label htmlFor="">Total Amount</label>
                    </div>
                  </div>
                  <div className="right">
                    <div className="sub-total">
                      <label htmlFor="">
                        ₹
                        {invoiceFormDetails.totalAmount
                          ? commaNumber(
                            Math.floor(
                              invoiceFormDetails.totalAmount
                            ).toFixed(2)
                          )
                          : 0}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="in-word">
                  <label htmlFor="">{amountInWords}</label>
                </div>
              </div>
              <div className="line-total"></div>
              <div className="disc-sign-main row">
                {/* <div className="col-lg-4 left ps-0">
                  <div className="description">
                    <textarea
                      className="form-control"
                      id="exampleFormControlTextarea1"
                      rows="3"
                      placeholder="Declaration"
                      name="declaration"
                      onChange={(e) => {
                        goodsHandleChange("declaration", e);
                      }}
                    ></textarea>
                  </div>
                </div> */}
                <div className="col-lg-7 left ps-0 ">
                  <div className="Terms-of-Services">
                    <div className="heading-TS">
                      <label htmlFor="">Terms of Services :</label>
                    </div>
                    <div className="term-conditions">
                      {logo?.terms ? logo.terms : ""}
                    </div>
                    {/* <ul>
                      <li>Terms of Services</li>
                      <li>Terms of Services</li>
                      <li>Terms of Services</li>
                      <li>Terms of Services</li>
                      <li>Terms of Services</li>
                    </ul> */}
                  </div>
                </div>
                <div className="col-lg-5 right pe-0 ps-0">
                  <label
                    className="upload d-block"
                    htmlFor="uploadLogo"
                    style={{ cursor: "pointer" }}
                  >
                    {/* <input
                      type="file"
                      name="authsign"
                      id="uploadLogo"
                      className="d-none"
                    /> */}
                    {logo.signtureLogo ? (
                      <>
                        {Dark === "lightMode" ? (
                          <img
                            src={logo.signtureLogo ? logo.signtureLogo : ""}
                            alt=""
                          />
                        ) : (
                          <img
                            src={logo.signtureLogo ? logo.signtureLogo : ""}
                            alt=""
                          />
                        )}
                      </>
                    ) : null}

                    {/* <br />
                    <label htmlFor="" className="text-up">
                      Upload your signature
                    </label>
                    <br />
                    <label htmlFor="" className="text-auth">
                      Authorized Signature
                    </label> */}
                  </label>
                </div>
              </div>
            </div>
            {formFormat === "bottom" && (
              // <div className="middle-top-logo text-center pb-3 mt-4">
              //   <div className="logo-top-left">
              //     <div className="pt-4">
              //       {Dark === "lightMode" ? (
              //         <img src={ic_upload} alt="" />
              //       ) : (
              //         <img src={ic_upload_dark} alt="" />
              //       )}{" "}
              //       <div className="up-text">
              //         <label htmlFor="">Upload your logo here</label>
              //       </div>
              //     </div>
              //   </div>
              // </div>
              <div className="middle-top-logo text-center pb-3 mt-4">
                {/* <div className="logo-top-left">
                <div className="pt-4">
                  {Dark === "lightMode" ? (
                    <img src={ic_upload} alt="" />
                  ) : (
                    <img src={ic_upload_dark} alt="" />
                  )}{" "}
                  <div className="up-text">
                    <label htmlFor="">Upload your logo here</label>
                  </div>
                </div>
              </div> */}
                <div className="right-logo logo-back">
                  <div className="img-right img">
                    <img
                      src={userData?.CompanyLogo}
                      alt=""
                      onError={(e) => e.target.src = Logo}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="text-end">
              <button
                disabled={loading ? true : false}
                className="form-submit-btn"
                type="submit"
                style={{ width: "98px", height: "29px", textAlign: "center" }}
                onClick={getFocus}
              >
                {loading ? (
                  <div
                    className="spinner-border text-secondar"
                    role="status"
                    style={{ width: "1rem", height: "1rem", margin: "-2 -2" }}
                  >
                    <span className="sr-only mt-3"></span>
                  </div>
                ) : invoiceAction === "edit" ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </div>
        </div>
      </Form>
      {/* Modal Of Add new row*/}
      <Modal
        show={addedNew}
        size="lg"
        onHide={() => setAddedNew(false)}
        centered
        className="main-add-row-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            New Product
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="add-row-content-modal">
              {/* Two inputs */}
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      Product Code
                    </label>
                    <input
                      type="text"
                      className="form-control input-add-row"
                      required
                      onChange={(e) => {
                        setNewProduct({
                          ...newProduct,
                          productCode: e.target.value,
                        });
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide a product code.
                    </Form.Control.Feedback>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      Product Name
                    </label>
                    <input
                      type="text"
                      className="form-control input-add-row"
                      required
                      onChange={(e) => {
                        setNewProduct({
                          ...newProduct,
                          productName: e.target.value,
                        });
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide a product name.
                    </Form.Control.Feedback>
                  </div>
                </div>
              </div>

              {/* Three Columns */}
              <div className="row mt-4">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      Unit Price
                    </label>
                    <input
                      type="text"
                      className="form-control input-add-row"
                      required
                      onChange={(e) => {
                        setNewProduct({
                          ...newProduct,
                          rate: Number(e.target.value),
                        });
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide Unit Price.
                    </Form.Control.Feedback>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      Account
                    </label>
                    <select
                      className="form-select input-add-row"
                      required
                      onChange={(e) => {
                        setNewProduct({
                          ...newProduct,
                          ledgerAccId: Number(e.target.value),
                        });
                      }}
                    >
                      <option value="">Please select</option>
                      {account &&
                        account.map((item) => (
                          <option value={item.id} key={item.id}>
                            {item.name}
                          </option>
                        ))}
                    </select>
                    <Form.Control.Feedback type="invalid">
                      Please provide an Account.
                    </Form.Control.Feedback>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      HSN Code
                    </label>
                    <select
                      className="form-select input-add-row"
                      required
                      onChange={(e) => {
                        setNewProduct({
                          ...newProduct,
                          hsnId: Number(e.target.value),
                          hsnCode: hsnCodes.filter((item) => {
                            return item.id === Number(e.target.value)
                              ? item.taxRate
                              : 0;
                          })[0].hsnCode,
                          taxRate: hsnCodes.filter((item) => {
                            return item.id === Number(e.target.value)
                              ? item.taxRate
                              : 0;
                          })[0].taxRate,
                        });
                      }}
                    >
                      <option value="">Please select</option>
                      {hsnCodes &&
                        hsnCodes.map((code) => (
                          <option value={code.id} key={code.id}>
                            {code.hsnCode}
                          </option>
                        ))}
                    </select>
                    <Form.Control.Feedback type="invalid">
                      Please provide HSN Code.
                    </Form.Control.Feedback>
                  </div>
                </div>
                <div className="col-md-4 mt-4">
                  <div className="form-group">
                    <label htmlFor="" className="label-add-row">
                      Tax Rate
                    </label>
                    <input
                      type="text"
                      className="form-control input-add-row"
                      disabled
                      required
                      value={newProduct.taxRate}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide Tax Rate
                    </Form.Control.Feedback>
                  </div>
                </div>
              </div>

              {/* Radio buttons */}
              {/* <div className="d-flex  justify-content-start mt-4">
                <div className="form-check mx-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={newProduct.isPurchase}
                    id="flexCheckDefault"
                    onChange={(e) => {
                      setNewProduct({
                        ...newProduct,
                        isPurchase: e.target.checked,
                        isSell: !e.target.checked,
                      });
                    }}
                  />
                  <label className="label-add-row" for="flexCheckDefault">
                    I Purchase This Item
                  </label>
                </div>

                <div className="form-check mx-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={newProduct.isSell}
                    id="flexCheckDefault2"
                    onChange={(e) => {
                      setNewProduct({
                        ...newProduct,
                        isSell: e.target.checked,
                        isPurchase: !e.target.checked,
                      });
                    }}
                  />
                  <label className="label-add-row" for="flexCheckDefault2">
                    I Sell This Item
                  </label>
                </div>
              </div> */}
            </div>
            <Modal.Footer className="mt-4">
              <Link
                to="#"
                className="cancelbtn text-center"
                onClick={() => setAddedNew(false)}
              >
                Cancel
              </Link>
              <button className="savebtn text-center" type="submit">
                Save
              </button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </main>
  );
};

// export default SalesServiceForm;
//         </Modal.Footer>
//           </Form>
//         </Modal.Body>
//       </Modal>
//     </main>
//   );
// };

export default SalesServiceForm;
